/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.customassistants.rpc.TemplateManagementAppService
 */

/**
 *  Cursor for custom assistants pagination
 */

/**
 *  Request to list installations of a specific custom assistant template on the current portal.
 *  Portal ID is obtained from the ChirpContext.
 */

/**
 *  Represents a custom assistant template installation on a portal.
 *  Contains information about which portal has the template installed and when.
 */

/**
 *  Response for listing installations of a specific custom assistant template
 */

export const listTemplateInstallsByGlobalIdRpc = {
  serviceName: 'com.hubspot.customassistants.rpc.TemplateManagementAppService',
  rpcName: 'listTemplateInstallsByGlobalId',
  auth: 'app',
  fingerprint: 'mpQo-2gDAI7P3AGo20fi9janqYkRlVxV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};